var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";

var ScrollbarInner = function (_Component) {
  _inherits(ScrollbarInner, _Component);

  function ScrollbarInner() {
    _classCallCheck(this, ScrollbarInner);

    return _possibleConstructorReturn(this, (ScrollbarInner.__proto__ || Object.getPrototypeOf(ScrollbarInner)).apply(this, arguments));
  }

  _createClass(ScrollbarInner, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "zebulon-scrollbar-thumb",
        id: "thumb-" + this.props.id,
        style: this.props.style
      });
    }
  }]);

  return ScrollbarInner;
}(Component);

export var Scrollbar = function (_Component2) {
  _inherits(Scrollbar, _Component2);

  function Scrollbar(props) {
    _classCallCheck(this, Scrollbar);

    var _this2 = _possibleConstructorReturn(this, (Scrollbar.__proto__ || Object.getPrototypeOf(Scrollbar)).call(this, props));

    _initialiseProps.call(_this2);

    _this2.state = { innerStyle: _this2.computeScrollbar(props) };
    return _this2;
  }

  _createClass(Scrollbar, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var innerStyle = this.computeScrollbar(nextProps);
      // if (!this.isDragging) {
      this.setState({ innerStyle: innerStyle });
      // }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var element = document.getElementById(this.props.id);
      if (element) {
        this.scrollbarPositions = element.getBoundingClientRect();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          width = _props.width,
          id = _props.id;

      if (!width) {
        return null;
      }
      // if (this.props.direction === "horizontal") {
      //   console.log("scrollbar", this.props.positionRatio);
      // }
      return React.createElement(
        "div",
        {
          className: "zebulon-scrollbar-bar",
          id: id,
          style: this.style,
          onMouseDown: this._handleMouseDown,
          onMouseUp: this._handleMouseUp,
          onMouseMove: this._handleMouseMove
        },
        React.createElement(ScrollbarInner, {
          id: "thumb-" + id,
          style: this.state.innerStyle,
          direction: this.props.direction,
          length: this.props.length,
          positionRatio: this.props.positionRatio,
          onScroll: this.props.onScroll
        })
      );
    }
  }]);

  return Scrollbar;
}(Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.computeScrollbar = function (props) {
    var direction = props.direction,
        length = props.length,
        width = props.width,
        positionRatio = props.positionRatio,
        displayRatio = props.displayRatio;


    var innerStyle = void 0;
    _this3.innerSize = Math.max(30, length * displayRatio);
    _this3.position = Math.min(length - _this3.innerSize, length * positionRatio);
    _this3.positionRatio = positionRatio;
    if (direction === "horizontal") {
      _this3.style = {
        // position: "absolute",
        height: width,
        width: length
        // left,
        // top
      };
      innerStyle = {
        position: "relative",
        height: width - 1,
        width: _this3.innerSize,
        left: _this3.position
      };
    } else {
      _this3.style = {
        height: length,
        width: width
      };
      innerStyle = {
        position: "relative",
        height: _this3.innerSize,
        width: width - 1,
        top: _this3.position
      };
    }
    return innerStyle;
  };

  this._handleMouseDown = function (e) {
    var event = {
      type: "scrollbar",
      direction: _this3.props.direction,
      initiator: e.target.id.startsWith("thumb") ? "thumb" : "bar",
      position: _this3.props.direction === "horizontal" ? e.clientX : e.clientY
    };
    e.preventDefault();
    if (event.initiator === "thumb") {
      _this3.isDragging = true;
      _this3.props._handleDrag("startDrag", event);
    } else if (!_this3.isDragging) {
      var _e$target$getBounding = e.target.getBoundingClientRect(),
          left = _e$target$getBounding.left,
          top = _e$target$getBounding.top;

      event.relativePosition = event.position - (_this3.props.direction === "horizontal" ? left : top);
      // console.log("click", left, e.clientX, event);
      return _this3.props._handleDrag("click", event);
    }
  };

  this._handleMouseUp = function (e) {
    _this3.isDragging = false;
    _this3.props._handleDrag("endDrag", { direction: _this3.props.direction });
  };

  this._handleMouseMove = function (e) {
    if (_this3.isDragging && e.buttons) {
      var event = {
        type: "scrollbar",
        direction: _this3.props.direction,
        position: _this3.props.direction === "horizontal" ? e.clientX : e.clientY
      };
      e.preventDefault();
      _this3.props._handleDrag("drag", event);
    } else if (_this3.isDragging && !e.buttons) {
      _this3.isDragging = false;
      _this3.props._handleDrag("endDrag", { direction: _this3.props.direction });
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-controls/lib/Scrollbar.js
// module id = 300
// module chunks = 0